module.exports = __webpack_public_path__ + "static/media/sort_up_active.5e24c821.svg";